import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as criteriaTopsportActions from "../../actions/criteriaTopsportActions";
import * as layoutActions from "../../actions/layoutActions";
import * as domainConstants from "../../constants/DomainConstants";
import * as types from "../../constants/ComponentConstants";
import * as documentActions from "../../actions/documentActions";
import { uploadOneFile, deleteOneFile } from "../common/DownloadUploadFilesHelper";

import AutoBindComponent from "../common/AutoBindComponent";
import BeoordelingscriteriaTopsportForm from "./BeoordelingscriteriaTopsportForm";
import mergeDeep from "../../util/mergeDeep.js";
import unsavedDataDialogHandler from "../common/UnsavedDataDialogHandler";
import showToastr, { showToastrInfo, showToastrSuccess, showToastrError } from "../../util/toastr.js";
import { getStore } from "../../store/configureStore";

import EasterEggHandler from "../common/EasterEggHandler";
import * as pageConstants from "../../constants/EasterEggConstants";

function hasFilesForDossierComponent(documenten, component) {
	if (documenten) {
		const files = documenten.find(x => x.name === component) ? documenten.find(x => x.name === component).files : [];
		if (files) {
			return files.length > 0 ? true : false;
		}
	}
	return false;
}

export default class BeoordelingscriteriaTopsportPageHelper {
	constructor(context, redirector) {
		this.dispatch = getStore().dispatch;
		this.context = context;
		this.redirector = redirector;
	}

	// ------------------------------------------------------------------------
	receiveProps(nextProps) {
		if (this.context.props.beoordelingscriteria !== nextProps.beoordelingscriteria) {
			if (nextProps.beoordelingscriteria.tabTitel) {
				this.context.props.loadLayout(nextProps.beoordelingscriteria.naam, nextProps.beoordelingscriteria.tabTitel, nextProps.dossierId, nextProps.beoordelingscriteria.typeDossier, null, nextProps.beoordelingscriteria && (nextProps.beoordelingscriteria.redenVanStatus.toString() != domainConstants.REDEN_VAN_STATUS_INGEDIEND.toString()));
			}
			this.context.setState({
				beoordelingscriteria: mergeDeep({}, nextProps.beoordelingscriteria),
				titleSet: nextProps.beoordelingscriteria.tabTitel
			});
		}
	}

	init() {
		const dossierId = this.context.props.dossierId;
		this.context.props.loadLayout("", "", dossierId);
		if (dossierId) {
			this.context.props.getContent(this.context.props.dossierId, domainConstants.DocumentTab.Criteria)
				.then(result => {
					if (result.success) {
						this.context.setState(
							{
								documenten: result.data
							});
					} else {
						showToastrError("Laden van het dossier is mislukt");
						throw new Error("getContent load failed"); //Stops promise
					}
				});
		}
		this.context.props.loadCriteria(dossierId);
	}

	// ------------------------------------------------------------------------
	onChange(event) {
		const field = event.target.name;
		const beoordelingscriteria = this.context.state.beoordelingscriteria;
		beoordelingscriteria[field] = event.target.value;

		if (event.target.value === "false") {
			switch (field) {
				case "gebruikVanNieuweTechnologien":
					beoordelingscriteria.nieuweTechnologien = null;
					break;
				case "ingespeeldOpNieuweOpkomendeDisciplines":
					beoordelingscriteria.mateVanInnovatie = null;
					break;

			}
		}
		return this.context.setState(
			{
				beoordelingscriteria: beoordelingscriteria,
				hasUnsavedChanges: true
			});
	}

	onDropFiles(component, files) {
		this.handleFileRequest(component, files, () => { files.forEach(file => uploadOneFile(this.context, this.context.props.uploadDocument, this.context.props.dossierId, domainConstants.DocumentTab.Criteria, component, file)); });
	}

	onDeleteFile(component, fileName) {
		this.handleFileRequest(component, fileName, () => { deleteOneFile(this.context, this.context.props.deleteDocument, this.context.props.dossierId, domainConstants.DocumentTab.Criteria, component, fileName); });
	}

	handleFileRequest(component, actionParam, fileProcess) {
		if (!this.context.state.fileSessionStarted) {
			this.context.props.startFileSession(this.context.props.dossierId, domainConstants.DocumentTab.Criteria)
				.then(result => {
					if (!result.success) {
						showToastrError("Verwerken van bestand is mislukt");
						throw new Error("File process failed"); //Stops promise
					} else {
						this.context.setState({ fileSessionStarted: true });
					}
				}).then(() => fileProcess(component, actionParam));
		}
		else
			fileProcess(component, actionParam);
	}

	onSave(event) {
		event.preventDefault();

		if (this.context.state.fileSessionStarted) {
			showToastrInfo("Verwerken van bestanden. Even geduld");

			this.context.props.endFileSession(this.context.props.dossierId, domainConstants.DocumentTab.Criteria)
				.then(result => {
					if (!result.success) {
						showToastrError(domainConstants.HAS_FILE_EXCEPTION);
						throw new Error("File process failed"); //Stops promise
					} else {
						this.context.setState({ fileSessionStarted: false });
						showToastrSuccess("Verwerken van bestanden gelukt");
						this.saveTheModel();
					}
				});
		} else {
			this.saveTheModel();
		}
	}

	saveTheModel() {
		const modelToSave = this.context.state.beoordelingscriteria;
		modelToSave.plannenBeschikbaar = hasFilesForDossierComponent(this.context.state.documenten, domainConstants.ComponentName.ArchitectPlannen);

		this.context.props.saveCriteria(this.context.state.beoordelingscriteria, this.context.state.documenten)
			.then((notification) => {
				let isSaved = showToastr(notification);
				if (isSaved)
					this.context.setState({ hasUnsavedChanges: false });
			});
	}
}